import React from 'react'
import { usePathname } from 'next/navigation'
import { useRoutingLocale } from '@/utils/l10n/useRoutingLocale'
import { PageLink } from '@/utils/PageLink'
import { Button } from 'ui/src/components/Button/Button'
import { TextField } from 'ui/src/components/TextField/TextField'
import { layout } from './DebugResumeSessionSection.css'

const INPUT_NAME = 'shopSessionId'

export function DebugResumeSessionSection() {
  const pathname = usePathname()
  const locale = useRoutingLocale()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formData = new FormData(event.currentTarget)
    const shopSessionId = formData.get(INPUT_NAME)

    if (typeof shopSessionId !== 'string') return

    const redirect = PageLink.session({ locale, shopSessionId, next: pathname })
    // We want hard navigation to work reliably in both pages and app routers
    window.location.replace(redirect.toString())
  }

  return (
    <form className={layout} onSubmit={handleSubmit}>
      <div style={{ flex: 1 }}>
        <TextField name={INPUT_NAME} label="Resume shop session" size="small" />
      </div>

      <Button variant="secondary" size="medium" type="submit" fullWidth={true}>
        Go
      </Button>
    </form>
  )
}
